import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  LiveScoreButton,
  LiveScoresHeader,
  LiveScoresHeaderBets,
  PreviousRoundCoef,
} from "./liveScoresComponentsStyles/LiveScoreHeaderStyles";

// import ArrowBasic from "./../../../../../lib/assets/icons/arrow-basic.svg"
// import ArrowBasicGreen from "./../../../../../lib/assets/icons/arrow-basic-green.svg"
import { AppContext, ValueContext } from "../../../../../context/createContext";
import { useTranslation } from "../../../../../locale/context";

import { ReactComponent as ArrowBasicSVG } from "./../../../../../lib/assets/icons/arrow-basic.svg";
import { ReactComponent as ArrowBasicGreenSVG } from "./../../../../../lib/assets/icons/arrow-basic-green.svg";

interface LiveScoreHeaderProps {
  previousRounds: boolean;
  setPreviousRounds: React.Dispatch<React.SetStateAction<boolean>>;
}

const LiveScoreHeader = ({
  previousRounds,
  setPreviousRounds,
}: LiveScoreHeaderProps) => {
  const { history } = useContext(AppContext);
  const {
    roundupdate: { state, value },
  } = useContext(ValueContext);
  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      title: t("common.liveBet.title"),
      currentRound: t("common.liveBet.currentRound"),
      prevRound: t("common.liveBet.prevRound"),
    };
  }, [t]);

  const [prevCoef, setPrevCoef] = useState<number>();

  const historyBtnTextValue = useMemo(() => {
    return previousRounds ? languagePack.currentRound : languagePack.prevRound;
  }, [previousRounds, languagePack]);

  useEffect(() => {
    setPrevCoef(history.my[0]); //TODO "my" or "all"
  }, []);

  useEffect(() => {
    if (state === 3) {
      setPrevCoef(value);
    }
  }, [state]);

  return (
    <LiveScoresHeader>
      <LiveScoresHeaderBets>
        <h1>{languagePack.title}</h1>
      </LiveScoresHeaderBets>
      {previousRounds && prevCoef && (
        <PreviousRoundCoef number={+prevCoef}>{prevCoef}x</PreviousRoundCoef>
      )}
      <LiveScoreButton
        onClick={() => setPreviousRounds((prevRound) => !prevRound)}
        prevRounds={previousRounds}
      >
        {previousRounds ? <ArrowBasicGreenSVG /> : <ArrowBasicSVG />}
        <h1>{historyBtnTextValue}</h1>
      </LiveScoreButton>
    </LiveScoresHeader>
  );
};

export default LiveScoreHeader;
